import React, { FC } from 'react';
import SCountdown from './Countdown.styles';
import { TCountdownProps } from './Countdown.types';

const Countdown: FC<TCountdownProps> = (props) => {
  return <SCountdown {...props} />;
};

export default Countdown;
